import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import Header from '../components/nav/Header.js';
import Footer from '../components/nav/Footer.js';
import '../styles/thank-you.css';
import content from '../assets/content.json';

export default function ContactPageInfoThankYou() {
  const thankYouContent = content.contactPageInfoThankYou;

  useEffect(() => {
    const url = new URL(window.location);
    if (url.search) {
      window.history.replaceState({}, document.title, url.pathname);
    }
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{content.metadata.contactPageInfoThankYouMetadata.title}</title>
        <meta name="description" content={content.metadata.contactPageInfoThankYouMetadata.description} />
      </Helmet>
      <div>
        <Header />
        <div className="thank-you-page-container">
          <div className="thank-you-content-wrapper">
            <div className="thank-you-content">
              <div className="content-text">
                {thankYouContent.thankYouText?.heading && (
                  <h1 className="thank-you-header">{thankYouContent.thankYouText.heading}</h1>
                )}

                {thankYouContent.thankYouText?.paragraphs?.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>

              {thankYouContent.listSections?.map((section, sectionIndex) => (
                <div key={`list-${sectionIndex}`} className="list-section list-section-thank-you">
                  {section.sectionTitle && <h3 className="list-section-title">{section.sectionTitle}</h3>}
                  {section.listType === "number" ? (
                    <ol>
                      {section.sectionItems?.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ol>
                  ) : (
                    <ul>
                      {section.sectionItems?.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              {thankYouContent.subHeadTwo && (
                <h3 className="thank-you-subhead">{thankYouContent.subHeadTwo}</h3>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
